<template>
  <MainLayout :title="trans('About')">
    <div
      class="sticky top-0 z-10 bg-theme-background"
      style="padding-top: var(--safe-area-inset-top)"
    >
      <div class="flex items-center p-4">
        <ADeepCircleButton
          class="flex-shrink-0"
          @click="router.push({ name: 'home' })"
        >
          <template #icon><ArrowLeftBold /></template>
        </ADeepCircleButton>
        <h1
          class="flex-1 truncate px-4 text-center font-primary text-lg font-medium"
        >
          {{ restaurant.name }}
        </h1>
        <div class="h-10 w-10 flex-shrink-0"></div>
      </div>
    </div>

    <div class="p-4">
      <div>
        <div v-if="restaurant.description" class="mb-5">
          {{ restaurant.description }}
        </div>
        <div v-else class="mb-5">{{ trans('Thanks for visiting us!') }}</div>
        <AboutRestaurant />
      </div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from '@menu/Shared/MainLayout.vue';
import ADeepCircleButton from '@menu/Shared/ADeepCircleButton.vue';
import AboutRestaurant from '@menu/Shared/AboutRestaurant.vue';
import ArrowLeftBold from '@/phosphoricons/ArrowLeftBold.vue';

import { trans } from '@menu/Utils/i18n';
import { useRouter } from 'vue-router';
import getRestaurant from '@menu/Utils/getRestaurant';

const router = useRouter();

const restaurant = getRestaurant();
</script>
